'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dAccount from "./mealorama.-Account.js";
import * as $j_mealorama$002e$002dAccount$002dPreferences from "./mealorama.-Account-Preferences.js";
import * as $j_mealorama$002e$002dScheduled$002dMeal$002dPreferences from "./mealorama.-Scheduled-Meal-Preferences.js";
var $p;
/** @constructor */
function $c_Lmealorama_Account$() {
}
export { $c_Lmealorama_Account$ as $c_Lmealorama_Account$ };
$p = $c_Lmealorama_Account$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Account$;
/** @constructor */
function $h_Lmealorama_Account$() {
}
export { $h_Lmealorama_Account$ as $h_Lmealorama_Account$ };
$h_Lmealorama_Account$.prototype = $p;
$p.m = (function() {
  return "Account";
});
$p.aLC = (function() {
  return new $j_mealorama$002e$002dAccount$002dPreferences.$c_Lmealorama_AccountPreferences(new $j_mealorama$002e$002dScheduled$002dMeal$002dPreferences.$c_Lmealorama_ScheduledMealPreferences($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_LocalTime$().qJ(9, 0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_LocalTime$().qJ(12, 0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_LocalTime$().qJ(19, 0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_LocalTime$().qJ(14, 0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_LocalTime$().qJ(19, 0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_Duration$().oa(60, 0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_Duration$().oa(60, 0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_Duration$().oa(60, 0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_Duration$().oa(30, 0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_Duration$().oa(60, 0)));
});
$p.aS1 = (function(x$0) {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(0));
  return new $j_mealorama$002e$002dAccount.$c_Lmealorama_Account($x_1.l, $x_1.h, x$0.g(1), x$0.g(2), x$0.g(3), x$0.g(4), (!(!x$0.g(5))));
});
var $d_Lmealorama_Account$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Account$, "mealorama.Account$", ({
  Ff: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_Account$ as $d_Lmealorama_Account$ };
var $n_Lmealorama_Account$;
function $m_Lmealorama_Account$() {
  if ((!$n_Lmealorama_Account$)) {
    $n_Lmealorama_Account$ = new $c_Lmealorama_Account$();
  }
  return $n_Lmealorama_Account$;
}
export { $m_Lmealorama_Account$ as $m_Lmealorama_Account$ };
//# sourceMappingURL=mealorama.-Account$.js.map
